import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import Hamburger from './Hamburger';
import '../style/components/_hamburger.scss';

const Navigation = () => {
    const [open, setOpen] = useState(false);

    const toggleDropdown = () => setOpen((prev) => !prev);

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    };

    const hiddenMenu = () => setOpen(false);

    const ref = useRef();

    useEffect(() => {
        const clickedOutside = (e) => {
            if (open && ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", clickedOutside)

        return () => {
            document.removeEventListener("mousedown", clickedOutside);
        }
    }, [open]);

    const [hamburgerOpen, setHamburgerOpen] = useState(false);
    const location = useLocation();

    const toggleHamburger = () => {
        setHamburgerOpen(!hamburgerOpen);
        document.body.style.overflow = !hamburgerOpen ? 'hidden' : 'unset';
    };

    const closeHamburger = () => {
        setHamburgerOpen(false);
        document.body.style.overflow = 'unset';
    }

    useEffect(() => {
        let lastScroll = window.scrollY;
        let hasScrolled = false;

        const header = document.querySelector("#header");
        if (header) {
            header.style.top = "0px";
        }

        const handleScroll = () => {
            const header = document.querySelector("#header");
            if (!header) return;

            if (!hasScrolled) {
                hasScrolled = true;
                lastScroll = window.scrollY;
                return;
            }

            const currentScroll = window.scrollY;

            if (currentScroll < lastScroll) {
                header.style.top = "0px";
            } else if (currentScroll > lastScroll && currentScroll > 100) {
                header.style.top = "-150px";
            }

            lastScroll = currentScroll;
        };

        hasScrolled = false;

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [location])

    return (
        //test
        <header id="header">
            <div className="header-container">
                <nav className="header-nav">
                    <NavLink to="/" className={(nav) => (nav.isActive ? "nav-active" : "")}>
                        <img className="logo-o3" src="../assets/img/logo-secondaire.png" alt="Accueil" />
                    </NavLink>

                    <div className="hamburger" onClick={toggleHamburger} onKeyDown={toggleHamburger}>
                        <Hamburger isOpen={hamburgerOpen} />
                    </div>

                    {/* Menu desktop */}
                    <ul className="desktop-menu" role="menu">
                        <li className="menu-item"><button
                            className="dropbtn"
                            aria-haspopup="true"
                            aria-expanded={open}
                            onClick={toggleDropdown}
                            onKeyDown={handleKeyDown}
                            type="button"
                        >
                            Nos formations ▼
                        </button>
                            <ul className="sub-menu" role="menu" style={{ display: open ? "block" : "none" }} onKeyDown={handleKeyDown} ref={ref}>
                                <li>
                                    <NavLink to="/conseiller-numerique" role="menuitem">
                                        Conseiller Numérique →
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/responsable-espaces-mediation-numerique" role="menuitem">
                                        Responsable d'Espaces de Médiation Numérique →
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/facilitateur-de-tiers-lieu" role="menuitem">
                                        Facilitateur de Tiers-Lieu →
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/piloter-un-tiers-lieu" role="menuitem" >
                                        Piloter un Tiers-Lieu →
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/testeur-logiciel" role="menuitem" onBlur={hiddenMenu}>
                                        Testeur Logiciel →
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink to="/certification-qualiopi" role="menuitem">
                                Certification Qualiopi
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/candidater" role="menuitem">
                                Candidater
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/qui-sommes-nous" role="menuitem">
                                Qui sommes-nous ?
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/contact" role="menuitem">
                                Nous Contacter
                            </NavLink>
                        </li>
                    </ul>

                    {/* Sidebar mobile */}
                    <div className={`sidebar ${hamburgerOpen ? 'open' : ''}`}>
                        <ul>
                            <li className="menu-item"><NavLink to="/nos-formations" onClick={closeHamburger}>
                                Nos formations ▼
                            </NavLink>
                                <ul className="sub-menu">
                                    <li>
                                        <NavLink to="/conseiller-numerique" onClick={closeHamburger}>
                                            Conseiller Numérique →
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/responsable-espaces-mediation-numerique" onClick={closeHamburger}>
                                            Responsable d'Espaces de Médiation Numérique →
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/facilitateur-de-tiers-lieu" onClick={closeHamburger}>
                                            Facilitateur de Tiers-Lieu →
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/piloter-un-tiers-lieu" onClick={closeHamburger}>
                                            Piloter un Tiers-Lieu →
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/testeur-logiciel" onClick={closeHamburger}>
                                            Testeur Logiciel →
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <NavLink to="/certification-qualiopi" onClick={closeHamburger}>
                                    Certification Qualiopi
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/candidater" onClick={closeHamburger}>
                                    Candidater
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/qui-sommes-nous" onClick={closeHamburger}>
                                    Qui sommes-nous ?
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact" onClick={closeHamburger}>
                                    Nous Contacter
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Navigation;